import React from 'react';
import styles from './LoginPasswordReset.module.css';
import Input from '../Form/Input';
import useForm from '../Hooks/useForm';
import { PASSWORD_RESET, USER_GET } from '../../api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-modal';

const LoginPasswordReset = () => {
  const senha = useForm('');
  const confirmaSenha = useForm('');
  const [password, setPassword] = React.useState('');
  const [email, setEmail] = React.useState('');
  const el = null;
  const url = window.location.href;
  const partesDaUrl = url.split('/');
  const { token } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const codigo = params.get('c');
  const [passChanged, setPassChanged] = React.useState(false);
  const navigate = useNavigate();
  const [requirementsMet, setRequirementsMet] = React.useState({
    length: false,
    // uppercase: false,
    // lowercase: false,
    // number: false,
  });

  const checkRequirements = (value) => {
    // const lengthRegex = /.{8,}/;
    // const uppercaseRegex = /[A-Z]/;
    // const lowercaseRegex = /[a-z]/;
    // const numberRegex = /[0-9]/;
    const lengthRegex = /^.{6,20}$/;

    setRequirementsMet({
      length: lengthRegex.test(value),
      // uppercase: uppercaseRegex.test(value),
      // lowercase: lowercaseRegex.test(value),
      // number: numberRegex.test(value),
    });
  };

  async function getUser() {
    const { url, options } = USER_GET(token);
    const response = await fetch(url, options);
    const { email } = await response.json();
    if (response.ok) {
      setEmail(email);
      // console.log('Pegou os dados');
    }
  }

  // React.useEffect(() => {
  //   getUser();
  // }, []);

  React.useEffect(() => {
    checkRequirements(senha.value);
  }, [senha.value]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (
      requirementsMet.length
      //  &&
      // requirementsMet.uppercase &&
      // requirementsMet.lowercase &&
      // requirementsMet.number
    ) {
      if (senha.value === confirmaSenha.value) {
        const { url, options } = PASSWORD_RESET({ senha: senha.value }, token);
        const response = await fetch(url, options);
        const json = await response.json();
        if (response.ok) {
          setPassChanged(true);
        }
      }
    }

    // const response = fetch();
  }

  function handleCloseModal() {
    setPassChanged(false);
    const cpf = atob(codigo);
    navigate('/');
  }

  return (
    <div className={styles.containerForm}>
      <Modal
        appElement={el}
        className={styles.modal}
        isOpen={passChanged}
        onRequestClose={() => handleCloseModal()}
        ariaHideApp={true}
      >
        <h2>
          Senha definida com sucesso
          <span>.</span>
        </h2>
        <button onClick={() => handleCloseModal()}>Fechar</button>
      </Modal>
      <h1>
        Definição de senha<span className={styles.ponto}>.</span>
      </h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          name="senha"
          type="password"
          label="Nova senha"
          placeholder="Digite a nova senha..."
          {...senha}
        />
        <Input
          name="confirma"
          type="password"
          label="Confirmar nova senha"
          placeholder="Confirme a nova senha..."
          {...confirmaSenha}
        />
        <ul>
          <li>
            {requirementsMet.length ? '✅' : '❌'} Deve conter entre 6 e 20
            caracteres
          </li>
          {/* <li>
            {requirementsMet.uppercase ? '✅' : '❌'} Deve conter pelo menos uma
            letra maiúscula
          </li>
          <li>
            {requirementsMet.lowercase ? '✅' : '❌'} Deve conter pelo menos uma
            letra minúscula
          </li>
          <li>
            {requirementsMet.number ? '✅' : '❌'} Deve conter pelo menos um
            número
          </li> */}
        </ul>
        <button>ENVIAR</button>
      </form>
    </div>
  );
};

export default LoginPasswordReset;
